import { readonly, ref } from 'vue'

/**
 * Mode discret : masque tous les montants à l'écran (consultation en public).
 * Préférence propre à l'appareil, mémorisée localement.
 */
const STORAGE_KEY = 'centime.amounts.hidden'

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

const hidden = ref(read())

export const amountsHidden = readonly(hidden)

export function toggleAmounts(): void {
  hidden.value = !hidden.value
  try {
    localStorage.setItem(STORAGE_KEY, hidden.value ? '1' : '0')
  } catch {
    // Stockage indisponible : la préférence vaut pour la session seulement.
  }
}
